import Flag_EN from '@/assets/img/Flag_EN.svg'
import Flag_ES from '@/assets/img/Flag_ES.svg'
import Flag_CA from '@/assets/img/Flag_CA.svg'
import Flag_FR from '@/assets/img/Flag_FR.svg'
import Flag_IT from '@/assets/img/Flag_IT.svg'
import Flag_DE from '@/assets/img/Flag_DE.svg'
import Flag_BR from '@/assets/img/Flag_BR.svg'
import { ComponentType, SVGProps } from 'react'

export const locales = ['en-US', 'es-ES', 'ca-ES', 'fr-FR', 'it-IT', 'de-DE', 'pt-BR'] as const;
export type Locale = (typeof locales)[number];
export const defaultLocale: Locale = 'en-US'

export const flags: { [key in Locale]: ComponentType<SVGProps<SVGSVGElement>> } = {
    'en-US': Flag_EN,
    'es-ES': Flag_ES,
    'ca-ES': Flag_CA,
    'fr-FR': Flag_FR,
    'it-IT': Flag_IT,
    'de-DE': Flag_DE,
    'pt-BR': Flag_BR
}